import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation, useSearchParams } from "react-router-dom";
import './HeaderLogin.scss';
import ModalLogin from "./ModalLogin";
import ModalSignup from "./ModalSignup";
import ModalForgotPassword from "./ModalForgotPassword";
import { useSetting } from "../../contexts/SettingContext";

interface HeaderLoginProps {
    onLoginSuccess: () => void;
}

export default function HeaderLogin({ onLoginSuccess, onOpenMenu }: HeaderLoginProps & { onOpenMenu: () => void }) {
    const { settings: appSettings } = useSetting();
    const [searchParams, setSearchParams] = useSearchParams();
    const [openLogin, setOpenLogin] = useState(false);
    const [openSignup, setOpenSignup] = useState(false);
    const [openForgot, setOpenForgot] = useState(false);

    useEffect(() => {
        if (searchParams.get('action') === 'login') {
            setOpenLogin(true);
            searchParams.delete('action');
            setSearchParams(searchParams, { replace: true });
        }
    }, [searchParams, setSearchParams]);

    return (
        <>
            <div className="styles_nav__QT6SS">
                <div className="MuiContainer-root styles_wrap__Ydvyw MuiContainer-maxWidthLg">
                    <div className="styles_WrapmenuFocus__1sojQ">
                        <div
                            className="MuiGrid-root styles_menu__EucYD MuiGrid-container MuiGrid-align-content-xs-space-between"
                            style={{ width: "100%", transition: "width 1s" }}
                        >
                            {/* LEFT */}
                            <div className="styles_group_left__u81Tb">
                                <Link
                                    className="styles_mobile_rootBase__8z7PQ mobie-r-4"
                                    to="/"
                                    id="logo"
                                    title="Tra cứu và đặt thuốc giá sỉ nhanh tại tamhanhpharma.com"
                                >
                                    <div>
                                        <span
                                            style={{
                                                boxSizing: "border-box",
                                                display: "inline-block",
                                                overflow: "hidden",
                                                width: "52px",
                                                height: "52px",
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                                position: "relative",
                                            }}
                                        >
                                            <img
                                                src={appSettings.logo || undefined}
                                                data-origin-url={appSettings.logo}
                                                alt="Tra cứu và đặt thuốc giá sỉ nhanh tại tamhanhpharma.com"
                                                title="Tra cứu và đặt thuốc giá sỉ nhanh tại tamhanhpharma.com"
                                                decoding="async"
                                                data-nimg="fixed"
                                                style={{
                                                    visibility: appSettings.logo ? 'visible' : 'hidden',
                                                    position: "absolute",
                                                    inset: 0,
                                                    boxSizing: "border-box",
                                                    padding: 0,
                                                    border: "none",
                                                    margin: "auto",
                                                    display: "block",
                                                    width: 0,
                                                    height: 0,
                                                    minWidth: "100%",
                                                    maxWidth: "100%",
                                                    minHeight: "100%",
                                                    maxHeight: "100%",
                                                }}
                                            />
                                            <noscript />
                                        </span>
                                    </div>
                                </Link>
                            </div>

                            <div className="show-1199 styles_lSection__YKbuK bg-[var(--primary-color)]" onClick={onOpenMenu}>
                                <div
                                    className="MuiBox-root css-70qvj9"
                                    aria-label="menu"
                                >
                                    <span className="img-wrapper">
                                        <img
                                            src="https://cdn-web-mobile-next.thuocsi.vn/images/header-v2/hamburger_icon.svg"
                                            alt="menu"
                                        />
                                    </span>
                                </div>
                            </div>

                            {/* CENTER */}
                            <div className="styles_group_center__e4Dvf">
                                <div className="styles_headerTopLink__4vSsm">
                                    <NavLink
                                        className={({ isActive }) => `styles_mobile_rootBase__8z7PQ${isActive ? ' active' : ''}`}
                                        to="/gioi-thieu"
                                    >
                                        <p className="MuiTypography-root MuiTypography-body2">
                                            Về chúng tôi
                                        </p>
                                    </NavLink>
                                </div>

                                <div className="styles_headerTopLink__4vSsm">
                                    <NavLink
                                        className={({ isActive }) => `styles_mobile_rootBase__8z7PQ${isActive ? ' active' : ''}`}
                                        to="/huong-dan"
                                    >
                                        <p className="MuiTypography-root MuiTypography-body2">
                                            Hướng dẫn đặt hàng
                                        </p>
                                    </NavLink>
                                </div>

                                <div className="styles_headerTopLink__4vSsm">
                                    <NavLink
                                        className={({ isActive }) => `styles_mobile_rootBase__8z7PQ${isActive ? ' active' : ''}`}
                                        to="/dieu-khoan-su-dung"
                                    >
                                        <p className="MuiTypography-root MuiTypography-body2">Điều khoản sử dụng</p>
                                    </NavLink>
                                </div>

                                {/* <div className="styles_headerTopLink__4vSsm">
                                    <a
                                        className="styles_mobile_rootBase__8z7PQ"
                                        target="_blank"
                                        href="https://hoptacbanhang.thuocsi.vn?utm_source=website&utm_medium=topbutton&utm_campaign=website_ref&utm_term=202305"
                                        rel="noreferrer"
                                    >
                                        <p className="MuiTypography-root MuiTypography-body2">
                                            Đăng ký bán hàng
                                        </p>
                                    </a>
                                </div> */}
                            </div>

                            {/* RIGHT */}
                            <div className="styles_group_right__0nB0c">
                                <div className="styles_group_btn__abUjC">
                                    <button
                                        className="MuiButtonBase-root styles_btn_register__2M4De"
                                        type="button"
                                        onClick={() => setOpenSignup(true)}
                                    >
                                        Đăng Ký
                                        <span className="MuiTouchRipple-root" />
                                    </button>

                                    <button
                                        className="MuiButtonBase-root styles_btn_signUp__Z35Tu"
                                        type="button"
                                        onClick={() => setOpenLogin(true)}
                                    >
                                        Đăng Nhập
                                        <span className="MuiTouchRipple-root" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* MODAL LOGIN */}
            {openLogin && (
                <ModalLogin
                    onClose={() => setOpenLogin(false)}
                    onLoginSuccess={onLoginSuccess}
                    onOpenForgotPassword={() => {
                        setOpenLogin(false);
                        setOpenForgot(true);
                    }}
                    onOpenSignup={() => {
                        setOpenLogin(false);
                        setOpenSignup(true);
                    }}
                />
            )}

            {openSignup && (
                <ModalSignup
                    onClose={() => setOpenSignup(false)}
                    onOpenLogin={() => {
                        setOpenSignup(false);
                        setOpenLogin(true);
                    }}
                />
            )}
            {openForgot && (
                <ModalForgotPassword
                    onClose={() => setOpenForgot(false)}
                />
            )}
        </>
    );
}